<template>
  <div>
    <div class="text-center mb-2">
      <img src="@/assets/theme/lsx.gif" class="m-2">
      <img src="@/assets/theme/bol_logo.jpeg" class="m-2">
      <img src="@/assets/theme/krx_logo.jpeg" class="m-2">
      <img src="@/assets/theme/lsc_logo.jpeg" class="m-2">
    </div>
    <div class="footer">
      Copyright @{{year}}. Lao Securities Exchange. All rights Reserved.
    </div>
  </div>
</template>
<script>
import moment from "@/moment"

export default {
  computed: {
    year() {
      return moment().format("YYYY")
    }
  }
}
</script>
<style lang="scss">
.footer {
  background-color: #004998;
  color: #FFFFFF;
  padding: 10px;
  text-align: center;
}
</style>
